var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPatientViewBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.697,
    height: 10.255,
    viewBox: "0 0 18.697 10.255",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_36830",
    "data-name": "Group 36830",
    transform: "translate(-1236 -339)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3505",
    "data-name": "Path 3505",
    d: "M9.348,0C3.562,0,0,5.127,0,5.127s3.309,5.127,9.348,5.127S18.7,5.127,18.7,5.127,15.134,0,9.348,0Zm0,9.057a3.9,3.9,0,0,1-3.868-3.93,3.868,3.868,0,1,1,7.734,0A3.9,3.9,0,0,1,9.348,9.057Z",
    transform: "translate(1236 339)",
    fill: "#5355d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3506",
    "data-name": "Path 3506",
    d: "M13.942,3.753c-1.816,0-3.289,1.024-3.289,2.288s1.472,2.288,3.289,2.288S17.23,7.305,17.23,6.041,15.758,3.753,13.942,3.753Zm-.461,2.175c-.586,0-1.059-.33-1.059-.737s.474-.738,1.059-.738,1.059.33,1.059.738S14.067,5.928,13.481,5.928Z",
    transform: "translate(1231.407 338.086)",
    fill: "#5355d8"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientViewBlue);
export default __webpack_public_path__ + "static/media/patient-view-blue.d67dc5b2fa0571c65d150a0a02259da3.svg";
export { ForwardRef as ReactComponent };